/**
 * TanStack Query staleTime/gcTime 프리셋.
 *
 * 호출처는 데이터 성격에 맞는 프리셋을 명시한다:
 *   useQuery({ ..., staleTime: STALE_TIME.STATIC })
 *
 * 프리셋이 부족하면 추가하되, 호출처에 매직 넘버를 두지 않는다.
 */

export const STALE_TIME = {
  /** 코드/enum 등 세션 중 거의 변하지 않는 정적 데이터. */
  STATIC: Infinity,
  /** TanStack Query 기본 동작 — 즉시 stale. mount 마다 background refetch. 목록·상세 등 신선도 우선. */
  DEFAULT: 5000,
} as const;

export const GC_TIME = {
  DEFAULT: 5 * 60_000,
} as const;
